import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import HeaderMenu from './components/HeaderMenu'; // Import HeaderMenu
import CoverflowSwiper from './components/CoverflowSwiper';
import VideoPlayerPage from './components/VideoPlayerPage';
import { Analytics } from "@vercel/analytics/react"

const App = () => {
    // Mobile-specific optimizations
    useEffect(() => {
        // Prevent zoom on double tap for mobile
        let lastTouchEnd = 0;
        const preventZoom = (event) => {
            const now = (new Date()).getTime();
            if (now - lastTouchEnd <= 300) {
                event.preventDefault();
            }
            lastTouchEnd = now;
        };

        // Add touch event listeners for mobile
        if ('ontouchstart' in window) {
            document.addEventListener('touchend', preventZoom, false);
        }

        // Disable pull-to-refresh on mobile
        const preventPullToRefresh = (e) => {
            e.preventDefault();
        };

        document.addEventListener('touchmove', preventPullToRefresh, { passive: false });

        return () => {
            document.removeEventListener('touchend', preventZoom);
            document.removeEventListener('touchmove', preventPullToRefresh);
        };
    }, []);

    return (
        <div className="app">
            {/* Render HeaderMenu globally */}
            <HeaderMenu />

            <Routes>
                {/* Define the main Swiper page */}
                <Route path="/" element={<CoverflowSwiper />} />
                
                {/* Define the Video Player page */}
                <Route path="/video/:videoId" element={<VideoPlayerPage />} />
            </Routes>
            <Analytics />
        </div>
    );
};

export default App;
